<template>
  <div class="box1">
      <div class="list-warp">
        <div class="top">
        <el-input v-model="input" class="input" placeholder="输入关键字搜索"></el-input>
        <el-button type="primary" @click="getData">搜索</el-button>
        <el-button type="primary" @click="showAddPage">添加配电房</el-button>
        <!-- <el-button type="primary" @click="showDispose">配置一次接线图</el-button> -->
        </div>
        <div class="contant-box">
        <nk-table :showPage="false" :data="tableData" :columns="columns" id="table">
            <el-table-column label="操作" width="100">
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
            </template>
            </el-table-column>
        </nk-table>
        </div>

        <el-dialog
        title="添加配电房"
        :visible.sync="dialogVisible"
        width="400px"
        :close-on-click-modal="false"
        >
        <el-form label-width="100px">
            <el-form-item label="配电房类型">
                <el-select
                    v-model="page.type"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(items,index) in typeData"
                      :key="index"
                      :label="items.value"
                      :value="items.id"
                    ></el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="配电房名称">
                <el-input v-model="page.name" placeholder="请输入页面名称" style="width:230px"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="margin-right: 100px;">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </span>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable.vue";
import { isNull } from "util";
export default {
    components: {
        NkTable
    },
    data() {
        return {
            input: "",
            tableData: [],
            columns: [
                { prop: "name", label: "配电房名称",show: true },
                { prop: "type", label: "类型", show: true },
                { prop: "displayName", label: "名称", show: true },
                { slot: "operation", show: true }
            ],
            page: {
                name: "",
                type: 0,
            },
            dialogVisible: false,
            typeData:[
                {id:0,value:"高压房"},
                {id:1,value:"低压房"}
            ]
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            let vm = this;
            vm.$api.diyComponent.getFrontEndDIYPages().then(res => {
                // if (res) {
                //   vm.tableData = vm.fuzzySearch(res.data, vm.input);
                // }
                let data=[
                    {
                        id:0,name:"高压室1",type:"炸",creatingTime:"2010",displayName:"少",operation:0
                    },
                    {
                        id:1,name:"高压室2",type:"炸",creatingTime:"2010",displayName:"少",operation:0
                    },
                    {
                        id:2,name:"高压室3",type:"炸",creatingTime:"2010",displayName:"少",operation:0
                    },
                    {
                        id:3,name:"高压室4",type:"炸",creatingTime:"2010",displayName:"少",operation:0
                    }
                ]
                vm.tableData=data
                vm.bus.$emit("getData", vm.tableData);
            });
        },
        /**
         * 模糊查找
         * list：数组
         * input：查找的字符串
         */
        fuzzySearch(list, input) {
        let arr = [];
        for (let index = 0; index < list.length; index++) {
            const obj = list[index];
            for (let key in obj) {
            if (obj[key].indexOf(input) > -1) {
                arr.push(obj);
                break;
            }
            }
        }
        return arr;
        },
        showAddPage() {
            let vm = this;
            vm.page = {
                type:0,
                name: "",
            };
            vm.dialogVisible = true;
        },
        showDispose(){
            let vm = this
            vm.$emit("bindShowDispose","");
        },
        save() {
            let vm = this;
            if (vm.page.name == "") {
                this.$message({
                    message: "配电房名称不能为空！",
                    type: "warning"
                });
                return;
            }
            console.log(isNull(vm.page.type))
            if (isNull(vm.page.type)) {
                this.$message({
                    message: "配电房类型不能为空！",
                    type: "warning"
                });
                return;
            }

            let content = {
                base: {
                width: vm.page.width,
                height: vm.page.height,
                type: vm.page.type,
                background: "#fff"
                },
                components: []
            };

            vm.$api.diyComponent
                .createFrontEndDIYPage(vm.page.name, JSON.stringify(content))
                .then(res => {
                if (res.success) {
                    vm.$message("添加页面成功！");
                    vm.dialogVisible = false
                    vm.getData();
                }
                });
        },
        handleClick(row) {
            let vm = this;
            vm.$emit("handleClick", row,vm.tableData);
        },

    }
};
</script>

<style scoped>
.box1{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
}
.list-warp {
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  height: 100%;
}
.top {
  padding: 20px;
  background:#fff;
  text-align: left;
  box-sizing: border-box;
}
.top .input {
  width: 200px;
  margin-right: 20px;
}
.contant-box {
  flex: 1;
}
.line {
  text-align: center;
}
.dialog-footer {
  text-align: center;
}
</style>